//   ####  #####   ####            ##     ##    ###    ##   ##
//  ##     ##     ##               ####   ##   ## ##   ##   ##
//   ###   #####  ##     ########  ##  ## ##  ##   ##  ##   ##
//     ##  ##     ##               ##    ###  #######   ## ##
//  ####   #####   ####            ##     ##  ##   ##    ###
/*
今見ているセクションを点灯させるナビ

<a href="#hoge" class="js-secNav js-secNav--hoge">
ナビゲーション
</a>
<section id="hoge" class="js-secNav-trigger" data-nav-target="hoge">
  section#hogeが画面に入ったらjs-secNav--hogeにクラスを当てる
</section>
*/

if (document.getElementsByClassName('js-secNav')[0]) {
  secNav()
}
function secNav() {
  const navItems = document.getElementsByClassName('js-secNav')
  const intObsOption = {
    rootMargin: '-50% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(secNavCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-secNav-trigger')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function secNavCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      // 接触アイテムを発見
      if (entry.isIntersecting) {
        // 全ての.activeを外す
        for (let index = 0; index < navItems.length; index++) {
          navItems[index].classList.remove('is_active')
        }
        const entryItem = entry.target
        const target = entryItem.dataset.navTarget // 制御対象名を取得

        // 対象アイテムをアクティブにする
        const targetItems = document.getElementsByClassName('js-secNav--' + target)
        for (let index = 0; index < targetItems.length; index++) {
          const targetItem = targetItems[index]
          targetItem.classList.add('is_active')
        }
        break // 以降の判定は飛ばす
      }
    }
  }
}
